export default __webpack_public_path__ + "static/media/en_organization.5556462b.png";